import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
	margin-top: 60px;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const Title = styled.h2`
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	font-size: 48px;
	letter-spacing: -0.01em;

	@media (max-width: 992px) {
		font-size: 32px;
	}
`;

export const Group = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 20px;
	gap: 15px;

	@media (max-width: 992px) {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const PromoItem = styled.div<{ $bgImg: string }>`
	background-image: ${({ $bgImg }) => `url('${$bgImg}')`};
	background-repeat: no-repeat;
	background-size: cover;
	background-position: bottom right;
	width: 100%;
	height: 185px;
	border-radius: 4px;
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 16px;

	@media (max-width: 992px) {
		padding: 12px;
	}
`;

export const Name = styled.div`
	font-size: 16px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const Desc = styled.div`
	font-weight: 600;
	font-size: 20px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.text.title};
	display: flex;
	align-items: center;
	gap: 5px;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.control.primary};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const Banner = styled.div<{ $isCom2: boolean; $bannerBgCom2: string; $bannerBgCom2Mob: string; $bannerBg: string }>`
	background-image: url(${({ $isCom2, $bannerBgCom2, $bannerBg }) => ($isCom2 ? $bannerBgCom2 : $bannerBg)});
	background-repeat: no-repeat;
	background-position: bottom;
	background-size: cover;
	border-radius: 8px;
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	gap: 50px;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 992px) {
		flex-direction: column;
		${({ theme, $isCom2, $bannerBgCom2Mob }) =>
			$isCom2 ? `background-image: url('${$bannerBgCom2Mob}');` : `background: ${theme.gradient.shareHologram};`}
	}
`;

export const BannerInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: baseline;
	margin-left: 40px;

	@media (max-width: 992px) {
		align-items: center;
		margin-left: 0;
		width: 100%;
	}
`;

export const BannerTitle = styled.div`
	font-weight: 700;
	font-size: 56px;
	letter-spacing: 0;
	color: ${({ theme }) => theme.colors.text.title};
	line-height: 1;

	@media (max-width: 992px) {
		font-size: 32px;
		text-align: center;
		margin-top: 20px;
	}
`;

export const BannerImage = styled.img`
	height: 100%;
	max-width: 526px;
	width: 100%;
`;
